import React from 'react'
import type { DropMenuItemId, DropMenuProps } from './dropMenu.types'

class DropMenuMethods extends React.PureComponent<DropMenuProps> {
    toggleSubMenu(e: React.MouseEvent<HTMLDivElement>, id: DropMenuItemId) {
        const p_ = this.props
        const activeToggleItems = p_.items
            .filter((item) => item.toggle && this.isActive(item.id))
            .map((item) => item.id)

        e.stopPropagation()

        if (this.isActive(id)) {
            this.closeItems(id)
        } else {
            p_.onChange([...activeToggleItems, id])
        }
    }
    handleClickOutside() {
        this.closeItems()
    }
    isActive = (id: DropMenuItemId) => {
        const p_ = this.props

        return p_.active.includes(id)
    }
    closeItems = (id?: DropMenuItemId) => {
        const p_ = this.props

        const activeToggleItems = p_.items.filter((item) => item.id !== id && item.toggle && this.isActive(item.id))
        const active = activeToggleItems.map((item) => item.id)
        p_.onChange(active)
    }
}

export default DropMenuMethods
